import { render, staticRenderFns } from "./SchoolActivitiesEntry.vue?vue&type=template&id=20e6407c&scoped=true"
import script from "./SchoolActivitiesEntry.vue?vue&type=script&lang=js"
export * from "./SchoolActivitiesEntry.vue?vue&type=script&lang=js"
import style0 from "./SchoolActivitiesEntry.vue?vue&type=style&index=0&id=20e6407c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6407c",
  null
  
)

export default component.exports